/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Nabídka`
};

const da_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Menu`
};

const de_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Menü`
};

const en_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Menu`
};

const es_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Menú`
};

const fr_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Menu`
};

const hu_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Menü`
};

const it_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Menu`
};

const nl_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Menu`
};

const pl_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Menu`
};

const pt_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Menu`
};

const sv_menu = /** @type {(inputs: {}) => string} */ () => {
	return `Meny`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const menu = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.menu(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("menu", locale)
	if (locale === "cs") return cs_menu(inputs)
	if (locale === "da") return da_menu(inputs)
	if (locale === "de") return de_menu(inputs)
	if (locale === "en") return en_menu(inputs)
	if (locale === "es") return es_menu(inputs)
	if (locale === "fr") return fr_menu(inputs)
	if (locale === "hu") return hu_menu(inputs)
	if (locale === "it") return it_menu(inputs)
	if (locale === "nl") return nl_menu(inputs)
	if (locale === "pl") return pl_menu(inputs)
	if (locale === "pt") return pt_menu(inputs)
	return sv_menu(inputs)
};